import {compose} from '@mui/system';
import {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';

import {getAcessos} from '../../pages/CRM/requests';
import api from '../../Services/API';

export default function useAuth() {
    const [authenticated, setAuthenticated] = useState(false);
    const [utilizador, setUtilizador] = useState('');

    const [rep, setRep] = useState('');
    const [oficina, setOficina] = useState({value: '', label: ''});
    const [userRepresentante, setUserRepresentante] = useState(null);
    const [nome, setNome] = useState('');
    const [acessos, setAcessos] = useState([]);
    const carrinhoInicial = JSON.parse(localStorage.getItem('carrinhoItems')) || [];
    const [carrinhoItems, setCarrinhoItems] = useState(carrinhoInicial != null ? carrinhoInicial : []);
    const history = useHistory();
    const [logout, setLogout] = useState(false);
    const [isCard, setIsCard] = useState(() => {
        var a = localStorage.getItem('isCard');
        if (a == null) {
            return false;
        }
        return JSON.parse(a);
    });

    const [catalogoCard, setCatalogoCard] = useState(() => {
        var a = localStorage.getItem('catalogoCard');
        if (a == null) {
            return false;
        }
        return JSON.parse(a);
    });
    useEffect(() => {
        localStorage.setItem('catalogoCard', catalogoCard);
    }, [catalogoCard]);
    const [openCards, setOpenCards] = useState(() => {
        var a = localStorage.getItem('openCards');
        if (a == null) {
            return false;
        }
        return JSON.parse(a);
    });
    const [path, setPath] = useState('');

    const adicionarItemAoCarrinho = item => {
        setCarrinhoItems([...carrinhoItems, item]);
    };

    useEffect(() => {
    
        localStorage.setItem('carrinhoItems', JSON.stringify(carrinhoItems));
    }, [carrinhoItems]);

    useEffect(() => {
        const carrinhoSalvo = localStorage.getItem('carrinhoItems');
        if (carrinhoSalvo) {
            setCarrinhoItems(JSON.parse(carrinhoSalvo));
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsCard(window.innerWidth < 900);
        };
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        setIsCard(false);
    }, []);

    useEffect(() => {
        localStorage.setItem('openCards', openCards);
    }, [openCards]);

    const [theme, setTheme] = useState(localStorage.theme);
    const colorTheme = theme === 'dark' ? 'light' : 'dark';

    useEffect(() => {
        const root = window.document.documentElement;
        root.classList.remove(colorTheme);
        root.classList.add(theme);
        localStorage.setItem('theme', theme);
    }, [theme, colorTheme]);

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            // api.defaults.headers.Authorization = `Bearer ${token}`;

            setAuthenticated(true);
        }
    }, []);

    function saveData(data) {
        setAuthenticated(true);
        var comps = [];
        if (data.componentes) {
            data.componentes.forEach(acesso => {
                comps.push(acesso.ecraComponente);
            });
        }

        setUtilizador(data.username);
        setUserRepresentante(data.representante);
        setNome(data.nome);

        handleOficina({value: data.oficina, label: data.oficinaNome});
    }

    async function handleLogin(username, password) {
        return api
            .post('/backend/login', {
                username: username,
                password: password,
                posto: '1',
            })
            .then(function (response) {
                if (response.data.success) {
                    setUtilizador(response.data.user.username);
                    localStorage.setItem('token', response.data.user.jwt);
                    localStorage.setItem('refresh', response.data.user.refreshToken);
                    localStorage.setItem('lan', 'POR');
                    api.defaults.headers.Authorization = `Bearer ${response.data.user.jwt}`;
                    saveData(response.data.user);
                    setAcessos(response.data.acessos);
                }
                return response;
            });
    }

    useEffect(() => {
        if (utilizador != '') {
            return api
                .post('/backend/verificaRepresentante/POR', {
                    id: utilizador,
                })
                .then(function (response) {
                    if (response.data.success) {
                        setRep(response.data.representante);
                    }
                });
        }
    }, [utilizador]);

    function handleOficina(oficina) {
        setOficina(oficina);
        localStorage.setItem('oficina', oficina.value);

        localStorage.setItem('oficina2', '0');
    }

    const formatarNumero = numero => {
        const partes = numero.toString().split('.');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

        partes[1] = partes[1] || '00';

        return partes.join(',');
    };

    async function verifAuthenticated() {
        const token = localStorage.getItem('token');
        const refreshToken = localStorage.getItem('refresh');

        await api
            .post('backend/api/login/RefreshToken', {
                token: token,
                refreshToken: refreshToken,
            })
            .then(function (response) {
                if (response.data.sucesso == 0) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('refresh', response.data.refToken);
                } else if (response.data.sucesso == 1) {
                    handleLogout();
                }
            })
            .catch(console.log);
    }

    function handleLogout() {
        setAuthenticated(false);
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        api.defaults.headers.Authorization = undefined;
        // history.push("/autenticacao");
    }

    async function handleRefresh() {
        localStorage.setItem('oficina2', '1');
        const token = localStorage.getItem('token');

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'content-type': 'application/json',
            },
        };
        const bodyParameters = {
            Posto: localStorage.getItem('posto'),
            oficina: localStorage.getItem('oficina'),
        };
        await verifAuthenticated();
        await api
            .post('/backend/api/login/RefHooks', bodyParameters, config)
            .then(function (result) {
                saveData(result.data);
                getAcessos(result.data.username).then(res => {
                    setAcessos(res.data.acessos);
                });
            })
            .catch(console.log);
    }

    return {
        handleLogin,
        utilizador,
        nome,
        acessos,
        rep,
        authenticated,
        oficina,
        handleRefresh,
        handleOficina,
        logout,
        handleLogout,
        path,
        setPath,
        isCard,
        openCards,
        carrinhoItems,
        adicionarItemAoCarrinho,
        setOpenCards,
        setIsCard,
        setCarrinhoItems,
        catalogoCard,
        setCatalogoCard,
        theme,
        setTheme,
        colorTheme,
        userRepresentante,
        verifAuthenticated,
        formatarNumero,
        setCarrinhoItems,
        carrinhoItems,
    };
}
